import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable"
import CustomModal from "../thema/tema1/component/CustomModal"
import axios from 'axios';
import jsPDF from "jspdf";
import UcretBelirle from "./UcretBelirle";
import UcretBelirlePopup from "./UcretBelirlePopup";
import BilgiGirisPopup from "./BilgiGirisPopup";

const tur = 4;

const active = {Home: "active"};
const durumlar = {
    1: "Araç Limana Giriş Yaptı",
    2: "Ek Bilgi Girişi Yapıldı",
    3: "Ücret Belirlendi",
    4: "Ücret Alındı",
    5: "Gemiye Yüklendi",
};
const gidecegiUlkeEnum = {
    0: "BELİRLENMEDİ",
    1: "YALOVA -> TRİESTE",
    2: "YALOVA -> BARİ",
    3: "YALOVA -> SETE",
};

class YalovaIhracat extends React.Component {
    componentDidMount() {
    }

    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            firmaId: 0,
            aciklama: "",
            dorsePlaka: "",
            cekiciPlaka: "",
            gidecegiUlke: "",
            cekiciPlakaEkOdeme: "",
            tarih: "",
            firmalar: [],
            tasimalar: [],
            content: [],
            contents: [],
            pageCount: 0,
            tasimaId: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            makbuzId: 0,
            makbuzDurum: 0,
            silModal: 'none',
            title: ["STATU","TT NUMARASI", "TARİH", "ÇEKİCİ PLAKA", "DORSE PLAKA", "GİDECEĞİ ÜLKE","ÜCRET", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.firmalarDoldur();
        this.handlePageClick({selected: 0});
        this.getTotalRow();
    }

    firmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/firma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let firmalar = res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>);
                this.setState({firmalar: firmalar});
            })
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
        if (e.target.name === "cekiciPlaka") {
            if( e.target.value)
            {
                var harfSayisi = e.target.value.length;
                if(harfSayisi>4)
                {
                    axios({
                        method: 'get',
                        url:  Properties.baseUrl+'/ekodeme/uyari/'+e.target.value.toUpperCase().replace(/\s/g, ''),
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization" : "Bearer " + localStorage.getItem("token")
                        }
                    })
                        .then(res => {
                            if(res.data.length>0)
                            {
                                this.setState({"cekiciPlakaEkOdeme": res.data.cekiciPlaka});
                                window.openModal("ekodeme-modal");
                            }
                        });
                }
            }
        }
    }
    ekOdemeModal = (e) => {
        window.location = '/ekodemeplakali/' + this.state.cekiciPlaka.toUpperCase().replace(/\s/g, '');
    }
    setSil = (e) => {
        this.setState({silId: e.id});
    }
    all = () => {
        alert("gf");
    }
    setDuzenle = (e) => {
        this.setState({dorsePlaka: e.dorsePlaka});
        this.setState({cekiciPlaka: e.cekiciPlaka});
        this.setState({gidecegiUlke: e.gidecegiUlke});
        this.setState({firmaId: e.firmaId});
        this.setState({tarih: e.tarih});
        this.setState({duzenleId: e.id});
        this.setState({showDuzenle: true});
    }
    geri = (e) => {
        this.setState({dorsePlaka: ""});
        this.setState({gidecegiUlke: 0});
        this.setState({firmaId: 0});
        this.setState({tarih: ""});
        this.setState({showDuzenle: false});
    }
    silModal = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/delete/' + this.state.silId,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.getTotalRow();
                this.handlePageClick({selected: 0});
                window.successful("Taşıma Silindi");
                this.setState({dorsePlaka: ""});
                this.setState({cekiciPlaka: ""});
                this.setState({gidecegiUlke: 0});
                this.setState({firmaId: 0});
                this.setState({tarih: ""});
            }).catch(res => {
            window.unsuccessful("Taşıma Silinemedi.");
        });
        window.disableModal();
    }
    tasimaSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/tasima/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    dorsePlaka: this.state.dorsePlaka.toUpperCase().replace(/\s/g, ''),
                    cekiciPlaka: this.state.cekiciPlaka.toUpperCase().replace(/\s/g, ''),
                    tarih: this.state.tarih,
                    firmaId: this.state.firmaId,
                    gidecegiUlke: this.state.gidecegiUlke,
                    durum: 1,
                    tur: tur,
                    id: (this.state.showDuzenle ? this.state.duzenleId : 0)
                }
            })
                .then(res => {
                    this.getTotalRow();
                    this.handlePageClick({selected: 0});
                    window.successful((this.state.showDuzenle ? "Taşıma Güncellendi." : "Taşıma Kaydedildi"));
                    this.setState({dorsePlaka: ""});
                    this.setState({cekiciPlaka: ""});
                    this.setState({gidecegiUlke: 0});
                    this.setState({firmaId: 0});
                    this.setState({tarih: ""});
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Taşıma Güncellenemedi." : "Taşıma Kaydedilemedi."));
            });
            if (this.state.showDuzenle)
                this.setState({showDuzenle: false});
        }
    }
    getTotalRow = (e) => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/sayfaliGetirTasimaToplam/'+tur,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                if(res.data < 10)
                {
                    this.setState({ endRow:res.data});
                }
                if(e != undefined ){
                    if( e.selected == undefined)
                    {
                        if(res.data > 10)
                        {
                            this.setState({ endRow:10});
                        }
                        else
                        {
                            this.setState({ endRow:res.data});
                        }
                        this.setState({ startRow: 0});
                    }
                    else {
                        this.setState({ startRow: (e.selected*10)+1});
                        this.setState({ endRow:((e.selected+1)*10)});
                    }
                }
                this.setState({totalRow: res.data});
                this.setState({pageCount: res.data / 10});
            });
    }
    handlePageClick = e => {
        this.setState({startRow: (e.selected * 10) + 1});
        this.setState({endRow: ((e.selected + 1) * 10)});
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/sayfaliGetirTasima/' + e.selected + "/" + tur,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.cekiciPlaka = eleman.cekiciPlaka;
                    elemanIc.dorsePlaka = eleman.dorsePlaka;
                    elemanIc.gidecegiUlke = eleman.gidecegiUlke;
                    elemanIc.tarih = eleman.tarih;
                    elemanIc.ttNumarasi = eleman.ttNumarasi;
                    getData.push(eleman);
                });
                this.setState({tasimalar: getData});
                let content = getData.map((item) =>
                    (<tr>
                        <td>{durumlar[item.durum]}</td>
                        <td>{item.ttNumarasi}</td>
                        <td>{item.tarih}</td>
                        <td>{item.cekiciPlaka}</td>
                        <td>{item.dorsePlaka}</td>
                        <td>{gidecegiUlkeEnum[item.gidecegiUlke]}</td>
                        <td>{item.gelir}</td>
                        <td>
                            <div className="row">
                                <div className="col-1">
                                    <button type="button" onClick={e => this.setDuzenle(item)}
                                            className="btn btn-block btn-outline-info"><i style={{"margin-left":" -4px"}} className="fas fa-wrench"></i>
                                    </button>

                                </div>
                                <div className="col-1">
                                    <button type="button" className="btn btn-block btn-outline-danger"
                                            onClick={e => this.setSil(item)} data-toggle="modal"
                                            data-target="#sil-modal"><i style={{"margin-left":" -4px"}} className="fas fa-trash"></i>
                                    </button>

                                </div>
                                <div className="col-1">

                                    <button type="button" onClick={e => this.bilgiGirisPopup(item.id)}
                                            className="btn btn-block btn-outline-info"><i style={{"margin-left":" -4px"}} className="fas fa-eye"></i>
                                    </button>
                                </div>
                                <div className="col-1">
                                    <button type="button" onClick={e => this.ucretBelirle(item.id)}
                                            className="btn btn-block btn-outline-info" ><i style={{"margin-left":" -4px"}} className="fas fa-money-bill-wave"></i>
                                    </button>
                                </div>

                                <div className="col-1">
                                    <button type="button"
                                            className="btn btn-block btn-outline-primary"
                                            onClick={e => this.durumGuncelle(item.id, 5)}
                                            data-toggle="modal" data-target="#modal-default"><i style={{"margin-left":" -4px"}} className="fas fa-ship"></i>
                                    </button>
                                </div>

                            </div>


                        </td>
                    </tr>));
                this.setState({content: content});
            });
    }


    ucretBelirle = (e) => {
        /*window.location = '/ucretbelirle/' + e;*/
        localStorage.setItem("tasimaId",e);
        const key = Date.now();
        const newContents = <UcretBelirlePopup key={key} tur={tur}></UcretBelirlePopup>;
        this.setState({contents:newContents});
        window.openModal("ucret-belirle-modal");
    }
    bilgiGirisPopup = (e) => {
        /*window.location = '/ucretbelirle/' + e;*/
        localStorage.setItem("tasimaId",e);
        const key = Date.now();
        const newContents = <BilgiGirisPopup key={key} tur={tur}></BilgiGirisPopup>;
        this.setState({contents:newContents});
        window.openModal("bilgi-giris-modal");
    }

    goruntule = (e) => {
        window.location = '/goruntule/' + e;
    }
    durumGuncelle = (id, durum) => {
        this.setState({makbuzId: id});
        this.setState({makbuzDurum: durum});
    }
    bilgiGiris = (e) => {
        window.location = '/bilgigiris/' + e;
    }
    ekOdeme = (e) => {
        window.location = '/ekodeme/' + e;
    }
    gemiYukle = () => {
        window.disableModal();
        axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                this.handlePageClick({selected: 0});
                window.successful((this.state.showDuzenle ? "Gemi Yükleme Güncellendi." : "Gemi Yükleme Kaydedildi"));
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Gemi Yükleme Güncellenemedi." : "Gemi Yükleme Kaydedilemedi."));
        });
    }
    makbuzYazdir = (e) => {
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        let gidecegiUlke = 0;
        let gidecegiUlkeStr = "";
        let tutar = 0;
        let yanici = 0;
        let tarih = 0;
        let plaka = "";
        let firma = "";
        let turStr = "";
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/get/'+this.state.makbuzId,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                console.log(res.data);
                firma = res.data.firmaAdi;
                tutar = res.data.gelir;
                yanici = res.data.yanici;
                tarih = res.data.tarih;
                plaka = res.data.cekiciPlaka + " / " + res.data.dorsePlaka;
                gidecegiUlke = res.data.gidecegiUlke;
                if(gidecegiUlke==1)
                {
                    gidecegiUlkeStr= "Trieste";
                }
                else if(gidecegiUlke==2)
                {
                    gidecegiUlkeStr= "Bari";
                }
                else if(gidecegiUlke==3)
                {
                    gidecegiUlkeStr= "Sete";
                }
                if(tur == 1 || tur == 4)
                {
                    turStr = "İHRACAT";
                }
                else
                {
                    turStr = "İTHALAT";
                }
                popupWin.document.write(`
    <html>
<!-- Google Font: Source Sans Pro -->
<style>
body{
font-size: 12px;
}
    .logo{
        margin-top: 40px;
        position: absolute;
        width: 150px;
        margin-left: -50px;
    }

    .years20{
        margin-top: 30px;
        position: absolute;
        margin-left: 550px;
    }
    .title{
        margin-top: 97px;
        position: absolute;
        margin-left: 357px;
    }
    .years20 img{
        width: 150px;
    }
    .firma{
    position: absolute;
        margin-top: 250px;
    }
    .plaka{
    position: absolute;
        margin-top: 274px;
    }
    .hat{
    position: absolute;
        margin-top: 346px;
    }
    .tur{
    position: absolute;
        margin-top: 346px;
        margin-left: 357px;
    }
    .toplam{
    position: absolute;
        margin-top: 250px;
        margin-left: 450px;
    }
    .tutar{
    position: absolute;
        margin-top: 274px;
        margin-left: 450px;
    }
    .yanici{
    position: absolute;
        margin-top: 298px;
        margin-left: 450px;
    }
    .aciklama{
    position: absolute;
        margin-top: 390px;
    }
    .enalt{
    position: absolute;
        margin-top: 424px;
    }
    .left
    {
        float: left;
    }
    .border
    {
        border: solid 1px #000;
        padding: 2px;
    }
    .width80{
        width: 80px;
    }
    .width50{
        width: 50px;
    }
    .width100{
        width: 100px;
    }
    .width140{
        width: 140px;
    }
    .width150{
        width: 150px;
    }
    .width200{
        width: 200px;
    }
    .width580{
        width: 580px;
            min-height: 15px;   
    }
    .width340{
        width: 340px;
        font-size: 10px;
    }
</style>
<head>
    <title>Print</title>
</head>
<body >
<div>
    <div class="header left">
        <div class="logo left">
            <img src="/thema/tema1/dist/img/makbuzlogo.png">
        </div>
        <div class="title left"> TAHSİLAT MAKBUZU</div>
        <div class="years20">
            <img src="/thema/tema1/dist/img/20years.png">
            <div style="margin-left: -60px;" ><div class="left tarih border width50">TARİH</div><div class="tarihsag left border width140">`+tarih+`</div></div>
        </div>
    </div>
    <div class="content left">
        <div>
            <div class="firma left"><div class="left tarih border width80">FİRMA</div><div class="tarihsag left border width200">`+firma+`</div></div>
            <div class="left plaka"> <div class="left tarih border width80">PLAKA</div><div class="tarihsag left border width200">`+plaka+` €</div></div>
            <div class="left toplam"> <div class="left tarih border width80">TOPLAM</div><div class="tarihsag left border width150">`+(tutar+yanici)+` €</div></div>
            <div class="left tutar"> <div class="left tarih border width80">TUTAR</div><div class="tarihsag left border width150">`+tutar+` €</div></div>
            <div class="left yanici `+(yanici!=0?"goster":"gosterme")+`"> <div class="left tarih border width80">YANİCİ</div><div class="tarihsag left border width150">`+yanici+` €</div></div>
            <div class="left hat"> <div class="left tarih border width80">Hat:</div><div class="tarihsag left border width150">`+gidecegiUlkeStr+`</div></div>
            <div class="left tur"> <div class="left tarih border width80">`+turStr+`</div><div class="tarihsag left border width150">X</div></div>
            <div class="left aciklama"> <div class="left tarih border width100">AÇIKLAMA</div><div class="tarihsag left border width580">`+this.state.aciklama+`</div></div>
            <div class="left enalt"> <div class="left tarih border width340">Aydıntepe Mah. 100.Yıl cad. No:12/33 P:Code: 34947 Tuzla/İstanbul</div><div class="tarihsag left border width340">ucarsoy@gmail.com | www.ucarsoy.com</div></div>
    </div>
        <div>
</div>
</div>
</div>
</body>

</html>
  
    `);
                popupWin.document.close();
            }).catch(res => {
        });

        /*window.history.back();*/
        window.disableModal();
        axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                this.handlePageClick({selected: 0});
                window.successful((this.state.showDuzenle ? "Makbuz Güncellendi." : "Makbuz Kaydedildi"));
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Makbuz Güncellenemedi." : "Makbuz Kaydedilemedi."));
        });
        this.handlePageClick({selected: 0});
        this.getTotalRow();
    }
    onClick = (e) => {
        window.inputmaskReady();
    }

    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu yalovaihracat="active"/>
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title"
                                    style={this.state.showDuzenle ? {display: 'none'} : {display: 'block'}}>Ekle</h3>
                                <h3 className="card-title"
                                    style={this.state.showDuzenle ? {display: 'block'} : {display: 'none'}}>Düzenle</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-2">
                                        <label>Firma Adı</label>
                                        <select onChange={this.onChange} name="firmaId" className="form-control select2"
                                                value={this.state.firmaId}>
                                            <option value={0} selected="selected">Firma Seç</option>
                                            {this.state.firmalar}
                                        </select>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Çekici</label>
                                        <input type="text" value={this.state.cekiciPlaka} className="form-control"
                                               name="cekiciPlaka" onChange={this.onChange}
                                               placeholder="Çekici Plaka"/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Dorse</label>
                                        <input type="text" value={this.state.dorsePlaka} className="form-control"
                                               name="dorsePlaka" onChange={this.onChange}
                                               placeholder="Dorse Plaka"/>
                                    </div>
                                    <div className="col-2">
                                        <label>Gideceği Ülke</label>
                                        <select name="gidecegiUlke" className="form-control select2"
                                                onChange={this.onChange} value={this.state.gidecegiUlke}>
                                            <option value={0} selected="selected">Tür Seç</option>
                                            <option value={1}>YALOVA -> TRİESTE</option>
                                            <option value={2}>YALOVA -> BARİ</option>
                                            <option value={3}>YALOVA -> SETE</option>
                                        </select>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1">Tarih</label>
                                        <input onClick={this.onClick} onKeyUp={this.onChange} type="text" name="tarih"
                                               value={this.state.tarih} class="form-control"
                                               data-inputmask-alias="datetime"
                                               data-inputmask-inputformat="dd/mm/yyyy HH:MM" data-mask/>
                                    </div>
                                    <div className="col-2">
                                        <label htmlFor="exampleInputEmail1"></label>
                                        <button onClick={this.tasimaSave}
                                                style={this.state.showDuzenle ? {display: 'none'} : {
                                                    margin: "10px",
                                                    display: 'block'
                                                }} type="button" className="btn btn-primary">Ekle
                                        </button>
                                        <button onClick={this.tasimaSave} style={this.state.showDuzenle ? {
                                            margin: "10px",
                                            float: "left",
                                            display: 'block'
                                        } : {display: 'none'}} type="button" className="btn btn-primary">Düzenle
                                        </button>
                                        <button onClick={this.geri} style={this.state.showDuzenle ? {
                                            float: "left",
                                            margin: "10px",
                                            display: 'block'
                                        } : {display: 'none'}} type="button" className="btn btn-info">Geri
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                    <div className="card">
                        <div className="card-body">
                            <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                         handlePageClick={this.handlePageClick}></CustomTable>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.gemiYukle} title={"Gemi Yükleme"}
                             content={"Gemi Yüklendi mi?"}></CustomModal>
                <CustomModal id={"makbuz-modal"} funcModal={this.makbuzYazdir} title={"Makbuz Çıktı"}
                             content={<div className="col-12">
                                 <label htmlFor="exampleInputEmail1">Açıklama</label>
                                 <input type="text" value={this.state.aciklama} className="form-control"
                                        name="aciklama" onChange={this.onChange}
                                        placeholder="Açıklama"/>
                             </div>}></CustomModal>
                <CustomModal id={"sil-modal"} funcModal={this.silModal} title={"Taşıma Silme"}
                             content={"Taşıma Silinsin mi?"}></CustomModal>
                <CustomModal buyuk={"true"} altbuton={"true"} id={"ucret-belirle-modal"}  funcModal={this.all} title={"ÜCRET BELİRLE"}
                             content={this.state.contents}></CustomModal>
                <CustomModal altbuton={"true"} id={"bilgi-giris-modal"}  title={"BİLGİ GİRİŞİ"}
                             content={this.state.contents}></CustomModal>
                <CustomModal altbuton={"true"} id={"ekodeme-modal"} funcModal={this.ekOdemeModal} title={"Ek Ödeme Borcu"} color={"red"}
                             content={this.state.cekiciPlaka.toUpperCase().replace(/\s/g, '') + " Plakalı Aracın Ek Ödeme Borcu Bulunmaktadır."}></CustomModal>
            </div>);
    }
}


export default YalovaIhracat;
